export default __webpack_public_path__ + "static/media/Bound_small_logo.22910c8e.png";